
import React, { useEffect, useState } from 'react';
import InnerHeader from './InnerHeader';
import { BASE_URL } from './BaseUrl';
import axios from "axios";
import { Link, useParams } from 'react-router-dom';
import decryptedUserId from '../Utils/UserID';

const IntimeSetting = () => {
  const { empolyeeid } = useParams();
      const [rows, setRows] = useState([]);

const formatDate = (inputDate) => {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = (`0${date.getMonth() + 1}`).slice(-2);
  const day = (`0${date.getDate()}`).slice(-2);
  return `${year}-${month}-${day}`; // ✅ Browser-friendly format
};

const fetchData = async () => {
  try {
    const res = await axios.post(`${BASE_URL}/get_Emp_IntimeSetting`, { empolyeeid });
    const data = res.data;

    console.log("Leave Structure Data:", data);

    if (data && data.length > 0) {
      const formattedData = data.map(item => ({
        ...item,
        FromDate: formatDate(item.FromDate),
        ToDate: formatDate(item.ToDate),
      }));
      setRows(formattedData);
    } else {
      setRows([{
        IntimeID: '',
        empolyeeid: '',
        InTime: '',
        FromDate: '',
        ToDate: ''
      }]);
    }
  } catch (err) {
    console.error("Error fetching leave structure:", err);
  }
};

      useEffect(() => {
              if (empolyeeid) {
                  fetchData();
              }
          }, [empolyeeid]);
  
      const handleInputChange = (e, index) => {
          const { name, value } = e.target;
          const updatedRows = [...rows];
          updatedRows[index][name] = value;
          setRows(updatedRows);
      };
  
      const addNewRow = () => {
  setRows([
    ...rows,
    {
      InTime: '',
      FromDate: '',
      ToDate: ''
    }
  ]);
};


       // 🔧 Helper function to convert to YYYY-MM-DD
 function formatDateToYYYYMMDD(dateString) {
     const date = new Date(dateString);
     if (isNaN(date)) return ""; // handle invalid date
     const year = date.getFullYear();
     const month = (`0${date.getMonth() + 1}`).slice(-2); // pad with 0
     const day = (`0${date.getDate()}`).slice(-2);
     return `${year}-${month}-${day}`;
 }

 const convertToDatabaseTimeFormat = (timeStr) => {
  try {
    const date = new Date(`1970-01-01T${timeStr}`);
    if (isNaN(date)) return '';
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
  } catch {
    return '';
  }
};


 const handleSave = async (e) => {
  e.preventDefault();

  // Validate all rows
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    if (!row.InTime || !row.FromDate || !row.ToDate) {
      alert(`Please fill in all fields in row ${i + 1}`);
      return;
    }
  }

  // Prepare all records
  const records = rows.map(row => ({
    IntimeID: row.IntimeID || null,
    InTime: convertToDatabaseTimeFormat(row.InTime),
    FromDate: formatDateToYYYYMMDD(row.FromDate),
    ToDate: formatDateToYYYYMMDD(row.ToDate),
  }));

  const data = {
    empolyeeid,
    createdBy: decryptedUserId(),
    updatedBy: decryptedUserId(),
    records
  };

  try {
    const res = await axios.post(`${BASE_URL}/save_or_update_Emp_IntimeSetting`, data);

    if (res.data.success) {
      alert("All records processed successfully!");
      fetchData(); // Reload updated records
    } else {
      alert("Some records failed: " + res.data.message);
    }
  } catch (err) {
    console.error("Error saving records:", err);
    alert("An error occurred while saving.");
  }
};







  const handleCancelRow = (indexToRemove) => {
          const updatedRows = rows.filter((_, index) => index !== indexToRemove);
          setRows(updatedRows);
      };
  
      return (
          <div className="container-fluid page-body-wrapper">
              <InnerHeader />
              <div className="main-panel">
                  <div className="content-wrapper">
                      <div className="d-flex flex-wrap">
                          <div className='px-2 mx-2'><Link to={`/employeepersonaldetails/${empolyeeid}`}><h4>Personal Information</h4></Link></div>
                          <div className='px-2 mx-2'><Link to={`/emailcredential/${empolyeeid}`}><h4>Email Credential</h4></Link></div>
                          <div className='px-2 mx-2'><Link to={`/academicqualificationsemp/${empolyeeid}`}><h4>Academic Qualification</h4></Link></div>
                          <div className='px-2 mx-2'><Link to={`/workexperience/${empolyeeid}`}><h4>Work Experience</h4></Link></div>
                          <div className='px-2 mx-2'><Link to={`/leavestructure/${empolyeeid}`}><h4>Leave Structure</h4></Link></div>
                          <div className='px-2 mx-2'><Link to={`/salarystructure/${empolyeeid}`}><h4>Salary Structure</h4></Link></div>
                          <div className='px-2 mx-2'><Link to={`/weeklyoff/${empolyeeid}`}><h4>Weekly Off</h4></Link></div>
                          <div className='px-2 mx-2'><Link to={`/intimesetting/${empolyeeid}`}><h4>Intime Setting</h4></Link></div>
                      </div>
  
                      <div className="col-lg-12 grid-margin stretch-card mt-4">
                          <div className="card">
                              <div className="card-body">
                                  <h2 className="card-title titleback">Intime Setting</h2>
                                  <hr />
  
                                  {rows.map((row, index) => (
                                      <div key={index} className="border p-3 mb-4 rounded bg-light">
                                          <div className="row">
                                              <div className="col-md-2">
                                                  <label>In time</label>
                                                  <input type="Time" className="form-control" name="InTime" value={row.InTime} onChange={(e) => handleInputChange(e, index)} />
                                              </div>
                                              <div className="col-md-2">
                                                  <label>Date from</label>
                                                  <input type="Date" className="form-control" name="FromDate" value={row.FromDate} onChange={(e) => handleInputChange(e, index)} />
                                              </div>
                                              <div className="col-md-2">
                                                  <label>To Date</label>
                                                  <input type="Date" className="form-control" name="ToDate" value={row.ToDate} onChange={(e) => handleInputChange(e, index)} />
                                              </div>
                                             
                                          </div>
  
                                          <div className="row mt-3">
                                              <div className="col-md-3 d-flex align-items-end">
                                                  <button className="btn btn-danger btn-sm" onClick={() => handleCancelRow(index)}>Remove</button>
                                              </div>
                                          </div>
                                      </div>
                                  ))}
  
                                  <div className="mt-4">
                                      <button type="button" className="btn btn-success" onClick={addNewRow}>Add Row</button>
                                      <button type="submit" className="btn btn-primary mx-2" onClick={handleSave}>Save</button>
                                      <button type="button" className="btn btn-light" onClick={() => window.location.reload()}>Close</button>
                                  </div>
  
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      );
}

export default IntimeSetting